import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { DigitalFormSetupVM, FormListV1, FormsVM, ModalIncidentRequired, ModalToggleForm, UpdateDigitalFormNameVM, UploadDigitalFormQuestionImageVM } from '../perform-induction/perform-induction';
import { SafetyInductionService } from '../services/safety-induction.service';
import { FileReaderEvent } from '../setup-implement/setup-implement.component';
import { DialogAddQuestionComponent } from './Components/dialog-add-question/dialog-add-question.component';

import { DialogSetupAnswersComponent } from './Components/dialog-setup-answers/dialog-setup-answers.component';


@Component({
  selector: 'app-create-safety-digital-form',
  templateUrl: './create-safety-digital-form.component.html',
  styleUrls: ['./create-safety-digital-form.component.scss']
})
export class CreateSafetyDigitalFormComponent implements OnInit {

  constructor(private _router: Router,private route: ActivatedRoute,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
    public dialog: MatDialog,) { }
  
  FormName:string="";
  DigitalFormSetupData:DigitalFormSetupVM;
  loading:boolean=false;
  CatId:number=0;
  isSendEmail:boolean
  ngOnInit() {

    this.route.params.subscribe(params => {
      this.CatId = +params['CatId'];
     
    });

    this.GETDigitalFormSetup();
  }

  GETDigitalFormSetup(){
    this.loading = true

    console.log("this.CatId", this.CatId)
    this._inductionService.GETDigitalFormSetup(this.CatId).subscribe(res => {
      console.log("GETDigitalFormSetup", res)
      this.DigitalFormSetupData = res;
      this.loading = false
      this.FormName = this.DigitalFormSetupData.Form.FormName

      this.isSendEmail = this.DigitalFormSetupData.Form.EmailonComplete

      let modifiedForms = []
      if(this.DigitalFormSetupData != null && this.DigitalFormSetupData){
        this.DigitalFormSetupData.FormCategories.map(m=>{
          let qs = this.DigitalFormSetupData.Questions.filter(f=>f.QuestionCatId == m.QuestionCatId)
          let _data = new FormListV1();

          qs.map((m,i)=>{
            if(i==0){
              m.ShowUpArrow=false
            }else{
              m.ShowUpArrow=true
            }

            if(i == (qs.length - 1)){
              m.ShowDownArrow = false
            }else{
              m.ShowDownArrow=true
            }
          })

          _data.FormCategory = m;
          _data.Questions = qs;

          modifiedForms.push(_data)
        })

        this.DigitalFormSetupData.FormListV1=modifiedForms
      }

    })
  }

  onClickAddSection(question){
    const dialogRef = this.dialog.open(DialogAddQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.DigitalFormSetupData.QuestionTypes,
        FormId:this.DigitalFormSetupData.Form.FormId,
       
        AddQuestion:false,
        
   
        AddSection:true
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.GETDigitalFormSetup();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  toggleImageEdit(QuestionId){
    
    this._inductionService.ToggleImageEdit(QuestionId).subscribe(res => {
      console.log("ToggleImageEdit", res)
      this.GETDigitalFormSetup();
    })
  }

  toggleAllowImage(QuestionId){
    
    this._inductionService.ToggleAllowImage(QuestionId).subscribe(res => {
      console.log("ToggleAllowImage", res)
      this.GETDigitalFormSetup();
    })
  }

  

  onClickDone(question){
    console.log("question",question)
    this._inductionService.ToggleDigitalFormQuestion(question.QuestionId).subscribe(res => {
      console.log("ToggleDigitalFormQuestion", res)
      this.GETDigitalFormSetup();
    })
  }

  toggleEmailOnComplete(){
    this._inductionService.ToggleDigitalFormEmailOnComplete(this.DigitalFormSetupData.Form.FormId).subscribe(res => {
      console.log("ToggleDigitalFormEmailOnComplete", res)
      this.GETDigitalFormSetup();
    })
    
  }

  onClickEditAnswer(question){

   

    const dialogRef = this.dialog.open(DialogSetupAnswersComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.DigitalFormSetupData.QuestionTypes,
        FormId:this.DigitalFormSetupData.Form.FormId,
        QuestionId:question.QuestionId,
        CatId:question.QuestionCatId,
        
        Title:question.QTitle,
        QuestionTypeId:question.QuestionTypeId,
        Description:question.QDescription,
        isAdditonalObs:false,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.GETDigitalFormSetup();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  onFileChanged(event,q) {
  

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
  
      reader.readAsDataURL(event.target.files[0]); // read file as data url
  
      reader.onload = (event:any) => { // called once readAsDataURL is completed
          var imageUrl = (event.target["result"]);
         //console.log("imageUrl",imageUrl)
         //console.log("Question",q)
         // this.ImagePreview = imageUrl;
         let paramas = new UploadDigitalFormQuestionImageVM();
         paramas.FormId = q.FormId
         paramas.QId = q.QuestionId
         paramas.Image = imageUrl

         this._inductionService.UploadDigitalFormQuestionImage(paramas).subscribe(res => {
          console.log("ToggleDigitalFormEmailOnComplete", res)
          this.GETDigitalFormSetup();
        })
      }
  }
  
  }

  onClickEditQuestion(question){
    const dialogRef = this.dialog.open(DialogAddQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.DigitalFormSetupData.QuestionTypes,
        FormId:this.DigitalFormSetupData.Form.FormId,
        QuestionId:question.QuestionId,
        CatId:question.QuestionCatId,
        AddQuestion:false,
        Title:question.QTitle,
        QuestionTypeId:question.QuestionTypeId,
        Description:question.QDescription
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.GETDigitalFormSetup();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  onClickAddQuestion(category){
    const dialogRef = this.dialog.open(DialogAddQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.DigitalFormSetupData.QuestionTypes,
        FormId:this.DigitalFormSetupData.Form.FormId,
        CatId:category.QuestionCatId,
        AddQuestion:true
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.GETDigitalFormSetup();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  onClickEditSection(section){
    console.log("section",section)
    //QuestionCatId
    const dialogRef = this.dialog.open(DialogAddQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionTypes:this.DigitalFormSetupData.QuestionTypes,
        FormId:this.DigitalFormSetupData.Form.FormId,
        EditSection:true,
        SectionId:section.QuestionCatId

      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.GETDigitalFormSetup();
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  FormNameChange(){
    let paramas = new UpdateDigitalFormNameVM();
         paramas.FormName = this.FormName
         paramas.FormId = this.DigitalFormSetupData.Form.FormId

         this._inductionService.UpdateDigitalFormName(paramas).subscribe(res => {
          console.log("ToggleDigitalFormEmailOnComplete", res)
         // this.GETDigitalFormSetup();
        })
  }

  onClickArrowDown(q){
  

    this._inductionService.OrderDwonForQuestions(this.DigitalFormSetupData.Form.FormId,q.Order, q.QuestionCatId).subscribe(res => {
      console.log("ToggleDigitalFormEmailOnComplete", res)
      this.GETDigitalFormSetup();
    })
    
  }

  onClickArrowUp(q){
    

    this._inductionService.OrderUpForQuestions(this.DigitalFormSetupData.Form.FormId,q.Order, q.QuestionCatId).subscribe(res => {
      console.log("ToggleDigitalFormEmailOnComplete", res)
      this.GETDigitalFormSetup();
    })
  }

}
